// Dark Mode Toggle Component
// Manages theme switching with localStorage persistence and system preference detection

(function() {
  var STORAGE_KEY = 'theme';
  var DARK = 'dark';
  var LIGHT = 'light';

  function getSystemPreference() {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return DARK;
    }
    return LIGHT;
  }

  function getStoredTheme() {
    return localStorage.getItem(STORAGE_KEY);
  }

  function setStoredTheme(theme) {
    localStorage.setItem(STORAGE_KEY, theme);
  }

  function getCurrentTheme() {
    return getStoredTheme() || getSystemPreference();
  }

  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    updateToggleIcons(theme);
  }

  function updateToggleIcons(theme) {
    var sunIcons = document.querySelectorAll('[data-theme-icon="sun"]');
    var moonIcons = document.querySelectorAll('[data-theme-icon="moon"]');

    sunIcons.forEach(function(icon) {
      icon.style.display = theme === DARK ? 'inline' : 'none';
    });

    moonIcons.forEach(function(icon) {
      icon.style.display = theme === LIGHT ? 'inline' : 'none';
    });
  }

  function toggleTheme() {
    var currentTheme = document.documentElement.getAttribute('data-theme') || getCurrentTheme();
    var newTheme = currentTheme === DARK ? LIGHT : DARK;
    setStoredTheme(newTheme);
    applyTheme(newTheme);
  }

  // Listen for system preference changes
  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function(e) {
      // Only auto-switch if user hasn't set a preference
      if (!getStoredTheme()) {
        applyTheme(e.matches ? DARK : LIGHT);
      }
    });
  }

  // jQuery onmount for toggle buttons
  $.onmount('[data-toggle="dark-mode"]', function() {
    var $el = $(this);

    // Update icons on mount
    updateToggleIcons(getCurrentTheme());

    $el.on('click', function(e) {
      e.preventDefault();
      toggleTheme();
    });
  });

  // Export for potential programmatic use
  window.DarkModeToggle = {
    toggle: toggleTheme,
    getCurrentTheme: getCurrentTheme,
    applyTheme: applyTheme
  };
})();
